/**
 * Ciudades
 */
export const CALI = 'CALI'
export const TUMACO = 'TUMACO'
export const MEDELLIN = 'MEDELLIN'
